import { render, staticRenderFns } from "./ComplainReport.vue?vue&type=template&id=67e6cd30&scoped=true&"
import script from "./ComplainReport.vue?vue&type=script&lang=js&"
export * from "./ComplainReport.vue?vue&type=script&lang=js&"
import style0 from "./ComplainReport.vue?vue&type=style&index=0&id=67e6cd30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e6cd30",
  null
  
)

export default component.exports